import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import NextButton from "../../NextButton/NextButton";

export function CategorizedList(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): ReactElement {
  const { ...rest } = props;

  return (
    <div className="CategorizedList" {...rest}>
      {props.children}
    </div>
  );
}

interface CategorziedListHeaderProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  primaryText?: string | null;
  secondaryText?: string;
}

export function CategorziedListHeader(
  props: PropsWithChildren<CategorziedListHeaderProps>
): ReactElement {
  const { primaryText, secondaryText, ...rest } = props;

  return (
    <div {...rest} className="CategorizedListHeader">
      <span className="mainText">{primaryText}</span>
      <span className="secondaryText">{secondaryText}</span>
    </div>
  );
}

interface CategorziedListContentProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isOpen: boolean;
}

export const CategorizedListContent = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<CategorziedListContentProps>
>((props, ref): ReactElement => {
  const { isOpen, children, ...rest } = props;
  return (
    <div
      {...rest}
      ref={ref}
      hidden={!isOpen}
      className={classNames("CategorizedListContent", rest.className)}
    >
      {children}
    </div>
  );
});

interface CategorizedListItemProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  primaryText?: string;
}

export function CategorizedListItem(
  props: PropsWithChildren<CategorizedListItemProps>
): ReactElement {
  const { primaryText, children, ...rest } = props;
  return (
    <div {...rest} className={classNames("CategorizedListItem", rest.className)}>
      <div className="content">
        <h3>{primaryText}</h3>
        {children}
      </div>
      <NextButton />
    </div>
  );
}
